import script from "./Epon.vue?vue&type=script&setup=true&lang=js"
export * from "./Epon.vue?vue&type=script&setup=true&lang=js"

import "./Epon.vue?vue&type=style&index=0&id=7c1822d5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1822d5"]])

export default __exports__